import { useContext, useEffect } from 'react';
import NavigationContext from '../../contexts/NavigationContext';

interface SidenavProps {
  children: JSX.Element;
}

export const Sidenav = ({ children }: SidenavProps): JSX.Element => {
  const { setItems, reset } = useContext(NavigationContext);

  useEffect(() => {
    setItems(children);

    return () => {
      reset();
    };
  }, [reset, setItems, children]);

  return <></>;
};

export default Sidenav;
